// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesFormConfig from '../../config/services-form-config';

export function deleteOffering({guid, offeringId, resourceId}) {
    return (dispatch) => {
        const dispatchFetched = (jsonResponse) => {
            dispatch({
                formName: 'deleteOffering',
                type: 'DELETE_OFFERING_FULFILLED',
                response:
                    jsonResponse ||
                    `Offering ID ${offeringId} with resource ID ${resourceId} has been successfully deleted.`,
            });
        };
        const dispatchError = (error) => {
            dispatch({
                type: 'DELETE_OFFERING_REJECTED',
                error,
            });
        };
        const actionParams = {
            servicesConfig: servicesFormConfig.deleteOffering,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'DELETE_OFFERING',
        });

        return actionsServiceCaller(actionParams, {}, `${guid}/${resourceId}`);
    };
}

export function deleteOfferingReset() {
    return (dispatch) => {
        dispatch({
            type: 'DELETE_OFFERING_RESET',
        });
    };
}
